(() => {
  const INPUT_SELECTOR = '.lgx-search-rotate, [lgx-search]';
  const DEFAULT_BASE_TEXT = 'Search ';
  const DEFAULT_INTERVAL_SECONDS = 4;
  const FPS = 24;

  const parseKeywords = (datasetValue) => {
    try {
      const parsed = JSON.parse(datasetValue || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map((entry) => (typeof entry === 'string' ? entry.trim() : ''))
        .filter((entry) => entry.length > 0);
    } catch (error) {
      console.warn('Search keyword rotation: failed to parse keywords', error);
      return [];
    }
  };

  const parseInterval = (datasetValue) => {
    const seconds = parseInt(datasetValue, 10);
    if (Number.isNaN(seconds) || seconds <= 0) {
      return DEFAULT_INTERVAL_SECONDS * 1000;
    }
    return seconds * 1000;
  };

  class ActivePlaceholder {
    constructor(input, base, placeholders, fBase = 24, fBuild = 12, fFull = 72, fRemove = 12) {
      this.input = input;
      this.base = base;
      this.placeholders = placeholders;
      this.fBase = fBase;
      this.fBuild = fBuild;
      this.fFull = fFull;
      this.fRemove = fRemove;
      this.state = 'base';
      this.timerId = null;
      this.ticks = 0;
      this.index = 0;
    }

    start() {
      if (!this.input || !this.placeholders || this.placeholders.length === 0) return;
      if (this.timerId) return;

      const step = () => {
        const currentWord = this.placeholders[this.index];

        switch (this.state) {
          case 'base':
            if (this.ticks > 0) {
              if (--this.ticks === 0) this.state = 'build';
            } else {
              this.input.placeholder = this.base;
              this.ticks = this.fBase;
            }
            break;
          case 'build': {
            if (this.ticks === 0) this.ticks = this.fBuild;
            const progress = (this.fBuild - this.ticks) / this.fBuild;
            const partial = currentWord.substring(0, Math.floor(progress * currentWord.length));
            this.input.placeholder = this.base + partial;
            if (--this.ticks === 0) this.state = 'full';
            break;
          }
          case 'full':
            if (this.ticks > 0) {
              if (--this.ticks === 0) this.state = 'remove';
            } else {
              this.input.placeholder = this.base + currentWord;
              this.ticks = this.fFull;
            }
            break;
          case 'remove': {
            if (this.ticks === 0) this.ticks = this.fRemove;
            const progress = this.ticks / this.fRemove;
            const partial = currentWord.substring(0, Math.floor(progress * currentWord.length));
            this.input.placeholder = this.base + partial;
            if (--this.ticks === 0) {
              this.state = 'base';
              this.index = (this.index + 1) % this.placeholders.length;
            }
            break;
          }
          default:
            this.state = 'base';
            this.ticks = 0;
        }
      };

      this.timerId = window.setInterval(step, 1000 / FPS);
    }

    stop() {
      if (this.timerId) {
        window.clearInterval(this.timerId);
        this.timerId = null;
      }
    }
  }

  const initInput = (input) => {
    if (input.dataset.lgxSearchRotate !== 'true') return;

    const keywords = parseKeywords(input.dataset.lgxSearchKeywords);
    if (!keywords.length) return;

    const baseText = input.dataset.lgxBaseText || DEFAULT_BASE_TEXT;
    const intervalMs = parseInterval(input.dataset.lgxSearchInterval);

    const animator = new ActivePlaceholder(input, baseText, keywords, 12, 12, Math.max(24, Math.round(intervalMs / (1000 / FPS))), 12);
    animator.start();

    const handleFocus = () => animator.stop();
    const handleInput = () => {
      if (input.value && input.value.trim().length > 0) {
        animator.stop();
      } else {
        animator.start();
      }
    };
    const handleBlur = () => {
      if (!input.value || input.value.trim().length === 0) {
        animator.start();
      }
    };

    input.addEventListener('focus', handleFocus);
    input.addEventListener('input', handleInput);
    input.addEventListener('blur', handleBlur);
  };

  const init = () => {
    document.querySelectorAll(INPUT_SELECTOR).forEach(initInput);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

